import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchBunkerFreshWaterDetail } from "../../apis/bunkerFreshWaterDetail";

export const fetchBunkerFreshWaterDetailData = createAsyncThunk(
    "bunkerFreshWaterDetail/fetchBunkerFreshWaterDetail",
    async ({ bunkers_fresh_water_id }: { bunkers_fresh_water_id: string }, { rejectWithValue }) => {
      try {
        const response = await fetchBunkerFreshWaterDetail(bunkers_fresh_water_id);
        return response;
      } catch (error: any) {
        console.log(error);
        return rejectWithValue(error.message);
      }
    }
  );